import { render } from "./SelectableSearchBox.vue?vue&type=template&id=1a38b7ac&scoped=true&ts=true"
import script from "./SelectableSearchBox.vue?vue&type=script&lang=ts"
export * from "./SelectableSearchBox.vue?vue&type=script&lang=ts"

import "./SelectableSearchBox.vue?vue&type=style&index=0&id=1a38b7ac&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a38b7ac"]])

export default __exports__